import { ListingFilter } from "../filters/ListingFilter";
import { Listing } from "./Listing";
import { PagedResponse } from "./PagedResponse";

enum BulkRequestEntryType
{
  None,
  SearchListings,
  CountListings
}

interface BulkRequestEntry {
  Id?: number;
  Type: BulkRequestEntryType;
  Data?: string;
}

interface BulkRequestCallbackEntry<TResponse> extends BulkRequestEntry {
  Callback: (res: TResponse) => void;
}

interface BulkRequest {
  Entries: BulkRequestEntry[];
}

interface BulkResponseItemModel {
  Request: BulkRequestEntry;
  Success: boolean;
  Response: any;
}

interface BulkResponse {
  Entries: BulkResponseItemModel[];
}

interface CountListingsResponse {
  Count: number;
}

class BulkRequestEntryBase<TResponse> implements BulkRequestCallbackEntry<TResponse> {
  Id?: number;
  Type: BulkRequestEntryType;
  Data: string;
  Callback: (res: TResponse) => void;

  constructor(type: BulkRequestEntryType, data: any, callback: (res: TResponse) => void) {
    this.Type = type;
    this.Data = JSON.stringify(data);
    this.Callback = callback;
  }
}

class CountListingsRequest extends BulkRequestEntryBase<CountListingsResponse> {
  constructor(filter: ListingFilter, callback: (res: CountListingsResponse) => void) {
    super(BulkRequestEntryType.CountListings, filter, callback);
  }
}

class SearchListingsRequest extends BulkRequestEntryBase<PagedResponse<Listing>> {
  constructor(filter: ListingFilter, callback: (res: CountListingsResponse) => void) {
    super(BulkRequestEntryType.SearchListings, filter, callback);
  }
}


export { BulkRequestEntry, BulkRequest, BulkResponseItemModel, BulkResponse, CountListingsRequest, SearchListingsRequest, BulkRequestCallbackEntry, BulkRequestEntryType }